import { insertAllowed } from "./structure";

export function addItemsToParent(parent, items) {
  if (!insertAllowed(parent, items)) {
    return [];
  }
  const relation = parent.childRel;
  const updated = [];
  for (const item of items) {
    const newParentage = { ...item[relation], [parent._id]: {} };
    updated.push(item.clone({ [relation]: newParentage }));
  }
  return updated;
}

export function removeItemsFromParent(parent, items) {
  const relation = parent.childRel;
  const updated = [];
  for (const item of items) {
    if (item[relation]?.[parent._id]) {
      const newParentage = { ...item[relation] };
      delete newParentage[parent._id];
      updated.push(item.clone({ [relation]: newParentage }));
    }
  }
  return updated;
}

export function setSingleParent(parent, items) {
  if (!insertAllowed(parent, items)) {
    return [];
  }
  return items.map((item) => item.clone({ [parent.childRel]: { [parent._id]: {} } }));
}
